import { render } from "./ProfessionalExperienceBox.vue?vue&type=template&id=5db4ee07&scoped=true"
import script from "./ProfessionalExperienceBox.vue?vue&type=script&lang=js"
export * from "./ProfessionalExperienceBox.vue?vue&type=script&lang=js"

import "./ProfessionalExperienceBox.vue?vue&type=style&index=0&id=5db4ee07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db4ee07"]])

export default __exports__